import { useLocation } from "react-router-dom";
import { SiteBrandMark } from "@/components/branding/SiteBrandMark";
import { PageTransition } from "@/layout/PageTransition";
import { Header } from "@/components/Header";
import { AppUpdateBanner } from "@/features/appUpdate/AppUpdateBanner";
import { useBranding } from "@/lib/branding/useBranding";
import { PageHeaderProvider } from "@/layout/PageHeaderProvider";
import { UserUiPreferencesProvider } from "@/lib/UserUiPreferencesProvider";
import { NavProvider } from "@/navigation/navContext";
import { AppSidebar } from "@/navigation/AppSidebar";
import { BottomNav } from "@/navigation/BottomNav";
import { CommandPalette } from "@/navigation/CommandPalette";
import { HomeStartupRedirect } from "@/navigation/HomeStartupRedirect";
import { ProgramSetupPanel } from "@/components/program-setup/ProgramSetupPanel";
import { TourAutoStart } from "@/components/tours/TourAutoStart";
import { ProgramSetupProvider } from "@/lib/programSetup";
import { TourProvider } from "@/lib/tours/TourContext";

export function Layout() {
  const { siteName } = useBranding();
  const { pathname } = useLocation();
  const isDashboard = pathname === "/";
  const isSitePlan = pathname === "/platzplan";
  const isPlanner = pathname.startsWith("/planner");
  const isMailInbox = pathname === "/mail";

  return (
    <PageHeaderProvider>
      <UserUiPreferencesProvider>
      <NavProvider>
        <TourProvider>
        <ProgramSetupProvider>
        <TourAutoStart />
        <HomeStartupRedirect />
        <div
          className={
            isSitePlan
              ? "eh-shell flex h-[100dvh] max-h-[100dvh] min-w-0 overflow-hidden bg-grouped text-label"
              : "eh-shell flex min-h-[100dvh] min-w-0 overflow-x-clip bg-grouped text-label"
          }
        >
          <AppSidebar />
          <div
            className={
              isSitePlan
                ? "eh-shell-column flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
                : "eh-shell-column flex min-w-0 flex-1 flex-col"
            }
          >
            <Header />
            <AppUpdateBanner />
            <main
              className={
                isDashboard
                  ? "eh-main-content dashboard-main mx-auto w-full min-w-0 max-w-[100rem] flex-1 px-3 pt-3 pb-[var(--eh-content-bottom-inset)] max-lg:px-3.5 sm:px-5 sm:pt-5 lg:px-6 lg:py-5"
                  : isSitePlan
                    ? "eh-main-content site-plan-main mx-auto flex h-full min-h-0 w-full min-w-0 max-w-[100rem] flex-1 flex-col overflow-hidden px-2 pt-2 pb-[var(--eh-content-bottom-inset)] max-lg:px-2.5 sm:px-4 sm:pt-2 lg:px-5 lg:py-2"
                    : isPlanner
                      ? "eh-main-content planner-main mx-auto flex w-full min-w-0 max-w-none flex-1 flex-col overflow-hidden px-2 pt-2 pb-[var(--eh-content-bottom-inset)] max-lg:px-2.5 sm:px-3 sm:pt-3 lg:px-4 lg:py-3"
                      : isMailInbox
                        ? "eh-main-content mail-main mx-auto w-full min-w-0 max-w-none flex-1 px-3 pt-3 pb-[var(--eh-content-bottom-inset)] max-lg:px-3.5 sm:px-4 sm:pt-4 lg:px-5 lg:py-4"
                        : "eh-main-content mx-auto w-full min-w-0 max-w-7xl flex-1 px-3 pt-3 pb-[var(--eh-content-bottom-inset)] max-lg:px-3.5 sm:px-5 sm:pt-5 lg:px-6 lg:py-5"
              }
            >
              <PageTransition />
            </main>
            <footer className="eh-main-footer hidden items-center justify-center gap-2 border-t border-separator bg-app/80 py-2 text-xs text-label-tertiary sm:flex lg:py-2.5">
              <SiteBrandMark to="" showName={false} className="pointer-events-none shrink-0" />
              <span>{siteName}</span>
            </footer>
          </div>
          <BottomNav />
          <CommandPalette />
          <ProgramSetupPanel />
        </div>
        </ProgramSetupProvider>
        </TourProvider>
      </NavProvider>
      </UserUiPreferencesProvider>
    </PageHeaderProvider>
  );
}
